export default __webpack_public_path__ + "static/media/sponsor.0d34f2f5.svg";